import React from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { ValueProposition } from '../components/ValueProposition';
import { UseCases } from '../components/UseCases';
import { ProductDeepDive } from '../components/ProductDeepDive';
import { TrustSecurity } from '../components/TrustSecurity';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-501" data-mp="2dhgt97gdo4c7">
      <SEO title="KittyPot | Shared Expenses, Made Simple" description="KittyPot helps groups track shared expenses, split costs fairly, and see the simplest way to settle up together." ogTitle="KittyPot | Shared Expenses, Made Simple" ogDescription="Track shared expenses, split costs fairly, and see the simplest way to settle up." path="/" jsonLd={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'KittyPot',
      url: 'https://www.kittypot.com',
      description: 'KittyPot helps groups track shared expenses, split costs fairly, see the simplest way to settle up, and settle directly in their preferred way.'
    }} data-id="element-502" data-mp="3kw1yt7vxqz9o" />
      <Navbar data-id="element-503" data-mp="2i007ebgc3qdl" />
      <main data-id="element-504" data-mp="2d777q1zq388d">
        <HeroSection data-id="element-505" data-mp="2d6p0kabiv9lo" />
        <ProblemSection data-id="element-506" data-mp="2d65sdlbobzku" />
        <HowItWorks data-id="element-507" data-mp="2d5w1zwmpvqem" />
        <ValueProposition data-id="element-508" data-mp="2d5dvm76cbvsz" />
        <UseCases data-id="element-509" data-mp="287krdjollbvc" />
        <ProductDeepDive data-id="element-510" data-mp="2895lx9awwut7" />
        <Pricing data-id="element-511" data-mp="288dri1t1x34i" />
        <TrustSecurity data-id="element-512" data-mp="285rj5zyc6jl8" />
        <FinalCTA data-id="element-513" data-mp="239ath1bhnx61" />
      </main>
      <Footer data-id="element-514" data-mp="23ac81frpr1si" />
    </div>;
}